import * as Actions from '../actions/actionTypes';

const initialState = {
    countries: [],
    paymentMethods: [],
    formAttributeSet: false,
    defaultCountry: null,
    skip: [4],
    lastRefId: null,
    addbank: false,
    connectedBanks: null,
    connectBank: false,
    pocFormAttribute: null,
    pocFees: null
}
function TransferReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.GET_COUNTRY:
            return {
                ...state,
                countries: action.payload.countryList,
                defaultCountry: action.payload.selectedCountry
            }
        case Actions.SET_LAST_REFRENCE_ID: {
            return {
                ...state,
                lastRefId: action.payload
            }
        }
        case Actions.GET_CONNECTED_BANKS: {
            return {
               ...state,
                connectedBanks: action.payload
            }
        }
        case Actions.CONNECT_BANK: {
            return {
               ...state,
                connectBank: action.payload
            }
        }
        case Actions.GET_POCKYT_BANK_FORM_DATA: {
            return {
               ...state,
                pocFormAttribute: action.payload
            }
        }
        case Actions.CLEAR_BANK_FORMDATA: {
            return {
                ...state,
                pocFormAttribute: null,
            }
        }
        case Actions.GET_POCKYT_FEES: {
            return {
               ...state,
                pocFees: action.payload
            }
        }
        case Actions.REPLACE_BANK: {
            return {
               ...state,
                bankToReplace: action.payload
            }
        }
        default: return state;
    }
}
export default TransferReducer;